export default {"src":"/_next/static/media/community.c1f954da.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};